import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import React from 'react';

import {
  OverflowMenu,
  OverflowMenuItem,
} from '../../Views/components/OverflowMenu';
import {useShouldAutoGeneratePanels} from '../../WorkspaceDrawer/Settings/hooks';
import {useClearPanels} from '../hooks/useClearPanels';
import {usePanelBankSectionsActions} from '../hooks/usePanelBankSectionsActions';

export const PanelBankControlsOverflowMenu = () => {
  const {openAllSections, closeAllSections} = usePanelBankSectionsActions();
  const onClearAllPanels = useClearPanels();

  const shouldAutoGeneratePanels = useShouldAutoGeneratePanels();
  const shouldShowClearAll = shouldAutoGeneratePanels === false;

  return (
    <OverflowMenu
      aria-label="More panel bank actions..."
      data-dd-action-name="More panel bank actions"
      data-test="pb-overflow-menu-trigger"
      variant="secondary">
      <OverflowMenuItem
        aria-label="Expand all sections"
        data-dd-action-name="Expand all sections"
        data-test="expand-all-sections"
        icon="expand-uncollapse"
        displayName="Expand all sections"
        onSelect={openAllSections}
      />
      <OverflowMenuItem
        aria-label="Collapse all sections"
        data-dd-action-name="Collapse all sections"
        data-test="collapse-all-sections"
        icon="collapse"
        displayName="Collapse all sections"
        onSelect={closeAllSections}
      />
      {shouldShowClearAll && (
        <>
          <DropdownMenu.Separator />
          <OverflowMenuItem
            icon="clear-all"
            displayName="Clear all panels"
            data-dd-action-name="Clear all panels"
            tooltipContent="Clear all panels and rebuild your workspace from scratch."
            onSelect={onClearAllPanels}
          />
        </>
      )}
    </OverflowMenu>
  );
};
